module.exports = __webpack_public_path__ + "static/img/ai_chat.281d5db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ai_chat.png
// module id = uRAm
// module chunks = 1